exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ba-report-table[data-v-6aac93ab]{width:100%;margin-top:4px}.ba-report-table>*[data-v-6aac93ab]{width:100%}.ba-action-cell[data-v-6aac93ab]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
